import classNames from 'classnames';
import CellTooltip from './CellTooltip';
import VibeIcon from '../../VibeIcon/VibeIcon';
import * as color from '../../../sass/color.scss';

function TextCell({
  className = '',
  text = '',
  icon,
  iconPlacement = 'left',
  iconSize = 16,
  iconColor = color.primary,
  hoverColor = color.secondary,
  tooltip = null,
  onClick = null,
}) {
  const iconHtml = icon && (
    <VibeIcon
      icon={icon}
      color={iconColor}
      hoverColor={onClick
        ? hoverColor
        : null}
      size={iconSize}
    />
  );

  return (
    <CellTooltip title={tooltip ?? text}>
      <div
        className={classNames('TextCell', className)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
        onClick={onClick}
      >
        {icon && iconPlacement === 'left' && iconHtml}

        <div
          className="text"
          style={{
            flexGrow: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {text}
        </div>

        {icon && iconPlacement === 'right' && iconHtml}
      </div>
    </CellTooltip>
  );
}

export default TextCell;
